var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPandas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 101,
    viewBox: "0 0 273 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 272,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.07 57.0188C114.212 57.0188 112.32 56.25 111.135 54.743V62.8839H107.414V42.7867H110.779L110.907 44.9974C112.061 43.2987 114.111 42.4014 116.067 42.4014C119.817 42.4014 122.579 45.5438 122.579 49.7101C122.579 53.8764 119.821 57.0206 116.07 57.0188ZM114.918 45.1602C112.738 45.1602 110.976 46.859 110.976 49.7119C110.976 52.5648 112.738 54.2672 114.918 54.2672C117.098 54.2672 118.86 52.5685 118.86 49.7155C118.86 46.8626 117.098 45.1602 114.918 45.1602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.605 56.6366L136.477 54.4258C135.323 56.1246 133.271 57.0219 131.315 57.0201C127.565 57.0201 124.803 53.8795 124.803 49.7132C124.803 45.5468 127.56 42.4044 131.315 42.4063C133.271 42.4063 135.323 43.3108 136.477 45.0023L136.605 42.7916H139.977V56.6366H136.605ZM132.471 45.1615C130.292 45.1615 128.529 46.8602 128.528 49.7132C128.526 52.5661 130.29 54.2666 132.47 54.2666C134.65 54.2666 136.413 52.5679 136.413 49.715C136.413 46.862 134.651 45.1615 132.471 45.1615Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.98 56.6385V48.9788C152.98 46.2869 152.051 45.3896 150.353 45.3896C148.589 45.3896 146.666 46.9906 146.666 48.9137V56.6385H142.946V42.7917H146.346L146.507 45.357C147.436 43.5932 149.519 42.4082 151.635 42.4082C155.32 42.4082 156.701 44.9735 156.701 48.4017V56.6403L152.98 56.6385Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.329 56.6418L170.2 54.4292C169.046 56.128 166.994 57.0253 165.041 57.0253C161.29 57.0253 158.528 53.8829 158.528 49.7166C158.528 45.5502 161.285 42.4096 165.041 42.4096C166.898 42.4096 168.789 43.1803 169.976 44.6855V37.4111H173.695V56.6418H170.329ZM166.195 45.1667C164.024 45.1667 162.253 46.8654 162.253 49.7166C162.253 52.5677 164.015 54.2664 166.195 54.2664C168.375 54.2664 170.137 52.5695 170.137 49.7166C170.137 46.8636 168.38 45.1667 166.195 45.1667Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.665 56.6442L187.537 54.4335C186.382 56.1322 184.331 57.0277 182.375 57.0277C178.625 57.0277 175.863 53.8872 175.863 49.719C175.863 45.5509 178.62 42.4121 182.375 42.4121C184.331 42.4121 186.382 43.3167 187.537 45.01L187.665 42.7974H191.03V56.6424L187.665 56.6442ZM183.531 45.1692C181.36 45.1692 179.589 46.8679 179.587 49.7208C179.586 52.5738 181.351 54.2671 183.529 54.2671C185.708 54.2671 187.473 52.5683 187.473 49.7154C187.473 46.8625 185.711 45.1692 183.531 45.1692Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.267 57.0943C197.311 57.0781 195.395 56.535 193.722 55.5222L194.332 52.9588C195.453 53.6317 197.152 54.4983 199.203 54.4983C200.678 54.4983 201.704 54.0496 201.704 52.8954C201.704 51.9022 200.645 51.5495 198.755 51.1008C195.357 50.3627 194.14 48.5681 194.14 46.6125C194.14 44.4325 195.839 42.3828 199.589 42.3828C201.865 42.3828 203.853 43.376 204.292 43.6329L203.683 46.0697C202.472 45.3407 201.091 44.9427 199.677 44.9155C198.172 44.9155 197.434 45.4275 197.434 46.2615C197.434 47.1896 198.397 47.6075 199.869 47.9602C203.524 48.7291 204.998 50.4278 204.998 52.2876C205.005 55.2672 202.825 57.0943 199.267 57.0943Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3576 33.3574H76.9995V42.4065H81.3576V33.3574Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3576 51.9453H76.9995V60.9944H81.3576V51.9453Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3576 45.0479H76.9995V49.3173H81.3576V45.0479Z",
    fill: "#FFCA00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3581 40.7979H70V70.8776H74.3581V40.7979Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2138 59.4121H83.8557V68.4612H88.2138V59.4121Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2138 40.8086H83.8557V49.8577H88.2138V40.8086Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2138 52.499H83.8557V56.7685H88.2138V52.499Z",
    fill: "#E70488"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0685 31H90.7104V61.0797H95.0685V31Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandas);
export default __webpack_public_path__ + "static/media/Pandas.88301b92eb7fb3286f89471c28b5eee9.svg";
export { ForwardRef as ReactComponent };